import { SelectMonth } from 'app/components/commonFilters/components'
import { COMPETITION_URL } from 'app/@common/constants'
import React, {useMemo} from 'react'
import { useAppMonthSelector } from './@hooks'
import { useContextSelector } from 'use-context-selector'
import { CompetitionAnalyzerReportExecutionContext } from 'app/pages/Competition/Analyzer2.1/Providers'
import { ParityReportExecutionContext } from 'app/pages/Parity/Analyzer2.1/Providers'
import { PackagesReportExecutionContext } from 'app/pages/Packages/Analyzer2.1/Providers'
import { getSection } from 'app/utils'


export default function AppHeaderMonth({ url = COMPETITION_URL.DATE_RANGE, customFirst = false }) {
    /*const optionsRef = useRef([])*/
    const { monthYear, setMonthYear } = useAppMonthSelector()
    
    const section = useMemo(() => getSection(window.location.href), [])
    const ReportExecutionContext = section === 'competition' 
        ? CompetitionAnalyzerReportExecutionContext 
        : section === 'packages' 
            ? PackagesReportExecutionContext 
            : ParityReportExecutionContext
    const idReportExecution = useContextSelector(ReportExecutionContext, ({ state }) => state?.idReportExecution)

    /*useEffect(() => {
        if (optionsRef.current.length) {
            const exists = optionsRef.current.some(opt => opt.value === monthYear)
            if (!exists && monthYear !== 'custom') {
                const firstOption = optionsRef.current[0]
                if (firstOption) {
                    const { value, lastDate } = firstOption
                    setMonthYear({
                        monthYear: value,
                        lastDate,
                        numMonths: optionsRef.current.length
                    });
                }
            }
        }
    }, [monthYear, setMonthYear]);*/

    return <div className="select-dates-header" style={{ border: 0 }}>
        <SelectMonth
            value={monthYear}
            onChange={({value}) => setMonthYear({ monthYear: value })}
            method="POST"
            urlAjax={url}
            // SelectAjaxSeeker's own `firstSelect` picks options[0] from whatever `onAjax`
            // RETURNS (the array actually rendered) — with `customFirst`, that's now "custom"
            // (reordered to the front for display), so its auto-select would race against and
            // override the manual setMonthYear below, defaulting to "custom" instead of the
            // current month. Disabled here because this component already replicates that
            // default-selection logic itself, off the ORIGINAL (pre-reorder) options[0].
            firstSelect={false}
            extraParams={{
                ...idReportExecution && { id_report_execution: idReportExecution }
            }}
            onAjax={(options = []) => {
                /*optionsRef.current = options;*/
                // Inside a report execution the custom option carries its stay-date scope (firstDate / lastDate):
                // the custom picker is limited to it, past dates included. Outside an execution firstDate is null.
                const executionCustomOption = options.find(opt => opt.value === 'custom')
                const scope = idReportExecution
                    ? { firstDate: executionCustomOption?.firstDate ?? null, lastDate: executionCustomOption?.lastDate ?? null }
                    : { firstDate: null }
                if (!monthYear || monthYear === 'custom') {
                    const { value } = options[0]
                    setMonthYear({ monthYear: value, lastDate: options[0].lastDate, numMonths: options.length, ...scope })
                } else {
                    if (!options.some(opt => opt.value === monthYear) && options[0]) {
                        const { value, lastDate } = options[0]
                        setMonthYear({ monthYear: value, lastDate, numMonths: options.length, ...scope })
                    } else {
                        setMonthYear({ ...scope })
                    }
                }

                // Reordena solo lo que se RENDERIZA en el desplegable — options[0] arriba
                // (siempre un mes real, "custom" va último en la respuesta del backend) se
                // sigue usando tal cual para la selección por defecto en el bloque anterior.
                if (!customFirst) return options
                const customIndex = options.findIndex(opt => opt.value === 'custom')
                if (customIndex <= 0) return options
                const reordered = [...options]
                const [customOption] = reordered.splice(customIndex, 1)
                reordered.unshift(customOption)
                return reordered
            }}
        />
    </div>
}